import Video from '@common/components/Video';
import { Cloudinary } from "@cloudinary/url-gen";
import { format } from '@cloudinary/url-gen/actions/delivery';
import React from 'react';
import Infography from '@common/components/Infography';

const filmData = [
  {
    "id": 2,
    "heading": "Sansaar - A D'Decor Brand TVC/2026",
    "thumbnailUrl": "bedding-2026-video-fallback-desktop",
    "mediaUrl": "https://res.cloudinary.com/dci1aiukm/video/upload/v1783073988/SANSAAR_Bedding_60s_-_16X9.mp4",
    "articleUrl": "https://sansaar.co.in/TVC.html",
    "publishDate": "2025-04-08T00:00:00.000Z",
    "description": "A deep dive into the technological innovations shaping the future of film production.",
    "type": "film",
    "isActive": true,
    "createdAt": "2025-04-08T00:00:00.000Z",
    "updatedAt": "2025-04-08T00:00:00.000Z"
  },
  {
    "id": 2,
    "heading": "Sansaar - A D'Decor Brand TVC/2025",
    "thumbnailUrl": "anycript_thumbnail_2",
    "mediaUrl": "https://res.cloudinary.com/dci1aiukm/video/upload/Sansaar-Ranveer-30sec-1920x1080.mp4",
    "articleUrl": "https://sansaar.co.in/TVC.html",
    "publishDate": "2025-04-08T00:00:00.000Z",
    "description": "A deep dive into the technological innovations shaping the future of film production.",
    "type": "film",
    "isActive": true,
    "createdAt": "2025-04-08T00:00:00.000Z",
    "updatedAt": "2025-04-08T00:00:00.000Z"
  },
  {
    "id": 1,
    "heading": "Sansaar - A D'Decor Brand TVC/2024",
    "thumbnailUrl": "banner-video-poster",
    "mediaUrl": "https://res.cloudinary.com/dci1aiukm/video/upload/home_video_banner_10_mb_1080p.mp4",
    "articleUrl": "https://sansaar.co.in/TVC.html",
    "publishDate": "1970-01-01T00:00:45.000Z",
    "description": "A deep dive into the technological innovations shaping the future of film production.",
    "type": "film",
    "isActive": true,
    "createdAt": "2024-10-08T13:41:07.000Z",
    "updatedAt": "2024-10-10T12:51:14.000Z"
  }
  // {
  //   "id": 17,
  //   "heading": "The Future of Cinema",
  //   "thumbnailUrl": "banner-video-poster",
  //   "mediaUrl": "brand_1080p",
  //   "articleUrl": "https://sansaar.co.in/TVC.html",
  //   "publishDate": "1970-01-01T00:00:45.000Z",
  //   "description": "A deep dive into the technological innovations shaping the future of film production.",
  //   "type": "film",
  //   "isActive": true,
  //   "createdAt": "2024-10-10T12:51:15.000Z",
  //   "updatedAt": "2024-10-10T12:51:15.000Z"
  // },
  // {
  //   "id": 31,
  //   "heading": "The Future of Cinema updated",
  //   "thumbnailUrl": "banner-video-poster",
  //   "mediaUrl": "brand_1080p",
  //   "articleUrl": "https://sansaar.co.in/TVC.html",
  //   "publishDate": "2024-08-10T00:00:00.000Z",
  //   "description": "A deep dive into the technological innovations shaping the future of film production.",
  //   "type": "film",
  //   "isActive": true,
  //   "createdAt": "2024-10-10T15:48:41.000Z",
  //   "updatedAt": "2024-10-10T15:48:41.000Z"
  // },
  // {
  //   "id": 47,
  //   "heading": "The Future of Cinema",
  //   "thumbnailUrl": "banner-video-poster",
  //   "mediaUrl": "brand_1080p",
  //   "articleUrl": "https://sansaar.co.in/TVC.html",
  //   "publishDate": "2024-08-10T00:00:00.000Z",
  //   "description": "A deep dive into the technological innovations shaping the future of film production.",
  //   "type": "film",
  //   "isActive": false,
  //   "createdAt": "2024-10-10T15:48:41.000Z",
  //   "updatedAt": "2024-10-11T05:18:15.000Z"
  // },
  // {
  //   "id": 61,
  //   "heading": "The Future of Cinema",
  //   "thumbnailUrl": "banner-video-poster",
  //   "mediaUrl": "brand_1080p",
  //   "articleUrl": "https://sansaar.co.in/TVC.html",
  //   "publishDate": "2024-08-10T00:00:00.000Z",
  //   "description": "A deep dive into the technological innovations shaping the future of film production.",
  //   "type": "film",
  //   "isActive": true,
  //   "createdAt": "2024-10-11T07:09:27.000Z",
  //   "updatedAt": "2024-10-11T07:09:27.000Z"
  // }
]

function FilmTabContent({ data }) {
  if (data.length === 0)
    data = filmData;

  return (
    <div className='lyt-advertise lyt-advertise--typ-container-sm'>
      {/* <div className='lyt-advertise__title-wrap'>
        <h2 className='lyt-advertise__title'>Sansaar - A D'Decor Brand TVC/2024</h2>
      </div> */}
      <div className='lyt-advertise__cont-wrap'>
        <ul className='lyt-advertise__film-list-wrap'>
          {data?.map((item, index) => {
            return (
              <li className='lyt-advertise__film-list-item' key={index}>
                <h4 className='lyt-advertise__film-title'>{item.heading}</h4>
                <Infography
                  imageUrl={item.thumbnailUrl}
                  viewInModal={true}
                  type="full"
                  videoUrl={item.mediaUrl}
                  videoPosterImg={item.thumbnailUrl}
                />
              </li>
            )
          })}
        </ul>
      </div>

    </div>
  )
}

export default FilmTabContent